import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MenuItem } from "../sidebar/sidebar";
import { classes } from "./nav-tabs.styles";

type Props = {
  tabs: MenuItem[];
};

export const NavTabs = ({ tabs }: Props) => {
  const location = useLocation();
  const [value, setValue] = useState(
    tabs.findIndex((tab) => tab.link === location.pathname)
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const activeTab = tabs.findIndex((tab) => tab.link === location.pathname);
    setValue(activeTab);
  }, [location.pathname, value, tabs]);

  return (
    <Box>
      <Tabs
        sx={classes.tabs}
        TabIndicatorProps={{
          style: { transition: "none" },
        }}
        value={value !== -1 ? value : 0}
        onChange={handleChange}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.label}
            component={NavLink}
            to={tab.link || ""}
            label={tab.label}
          />
        ))}
      </Tabs>
    </Box>
  );
};
